import script from "./OnboardingAiOkrStructureStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiOkrStructureStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiOkrStructureStep.vue?vue&type=style&index=0&id=c9427aa2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9427aa2"]])

export default __exports__